import { Elements } from "@stripe/react-stripe-js";
import React, { useEffect, useState } from "react";
import Loader from "./Loader";
import { loadStripe } from "@stripe/stripe-js";
import { STRIPE_ID } from "../firebase.config";

const ElementsWrapper = ({children}) => {

  const [stripePromise, setStripePromise] = useState(false);

  useEffect(() => {
    if(!stripePromise){
      setStripePromise(loadStripe(STRIPE_ID));
    }
  }, [stripePromise])

  if( !stripePromise){
        return <div className="container mx-auto w-full h-[100px] flex items-center justify-center">
        <Loader />
      </div>
    }
  return <Elements stripe={stripePromise}>{children}</Elements>;
};

export default ElementsWrapper;
